import { useMemo } from "react";
import { api } from "../../lib/api";
import DutyHistoryPanel from "../duty-history/DutyHistoryPanel";

export default function OrganizationDutyHistory({ organizationId, active }: { organizationId: string; active: boolean }) {
  const queries = useMemo(() => ({ getOptions: () => api.getDutyHistoryOptions(organizationId), getHistory: (userId: string, date: string) => api.getDutyHistory(organizationId, userId, date) }), [organizationId]);
  return <DutyHistoryPanel key={organizationId} scopeKey={`ops:${organizationId}`} {...queries} getMapConfig={api.getGoogleMapsConfiguration} active={active} />;
}
